import React from "react";
import { Link } from "react-router-dom";
import footerLogo from "../../assets/icons/footerLogo.svg";

const Footer = () => {
  return (
    <>
      <div className="bg-green/95 px-16 mt-10 md:mt-16">
        <div className="text-center pt-5 md:pt-10">
          <Link to="/">
            <img className="m-auto h-8 md:h-auto" src={footerLogo} alt="" />
          </Link>
        </div>
        <ul className="text-md md:text-lg text-white py-4 md:py-10 flex flex-wrap md:flex-nowrap justify-center items-center space-x-4 md:space-x-20">
          <li className="">about</li>
          <li className="">products</li>
          <li className="">carrers</li>
          <li className="">help</li>
          <li className="">privacy policy</li>
        </ul>
      </div>
      <div className="bg-green text-white">
        <p className="py-4 text-center text-md md:text-lg">
          © 2020. all rights reserved
        </p>
      </div>
    </>
  );
};

export default Footer;
